import {useState} from 'react'
import useApi from '../../../services/useApi'

export default function useProductBadgesOperations() {
  const [isLoading, setLoading] = useState(false)
  const Api = useApi()

  const addProductBadge = (data: any, setError: any) => {
    return Api.post('/products/product-badges', data, {
      setLoading,
      successMessage: 'Product badge created successfully',
      refetch: 'product-badges-list',
      setUseFormError: setError,
      navigate: '/products/product-badges'
    })
  }

  const updateProductBadge = (data: any, badgeId: string, dirtyFields: any, setError: any) => {
    return Api.patch(`/products/product-badges/${badgeId}`, data, {
      setLoading,
      successMessage: 'Product badge updated successfully',
      refetch: ['product-badges-list', `product-badge-details-${badgeId}`],
      dirtyFields: dirtyFields,
      setUseFormError: setError,
      navigate: '/products/product-badges'
    })
  }

  return {
    addProductBadge,
    updateProductBadge,
    isOperationLoading: isLoading,
  }
}
